import { Component, OnInit } from '@angular/core';
import { KeyValue } from '@angular/common';
import { switchMap } from 'rxjs/operators';
import { Discover } from 'src/app/models';
import { Observable } from 'rxjs/internal/Observable';
import { LandingPageService } from './landing-page.service';
import { Subscription } from 'rxjs';
import { ScreenSizeService, DialogService } from 'src/app/services';

@Component({
    selector: 'cm-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent implements OnInit {
    protected discover: Discover | null;
    protected disableRestore: boolean;
    private params: KeyValue<string, any>[] = [{ key: "Platform", value: "Web" }];
    screenWidth: number;
    private screenWidthSubscription$: Subscription | null;
    protected displayChangePassword: boolean = false;
    protected displayReport: boolean = false;

    constructor(
        private landingPageService: LandingPageService,
        private screenSizeService: ScreenSizeService,
        private dialogService: DialogService
    ) {
        this.discover = null;
        this.disableRestore = false;
        this.screenWidth = 0;
        this.screenWidthSubscription$ = null;
    }

    ngOnInit() {
        this.dialogService.changePasswordDialogState$.subscribe(state => {
            this.displayChangePassword = state;
        });

        this.dialogService.reportDialogState$.subscribe(state => {
            this.displayReport = state;
        });

        this.landingPageService.getDiscover().subscribe((resp: Discover) => {
            console.log('discover:', resp);
            this.discover = resp;
            //Testing
            if (!resp) {
                this.discover = {
                    Code: 0,
                    Message: '',
                    Id: '',
                    Username: '',
                    Name: '',
                    Currency: '',
                    Cash: 0,
                    Chip: 0,
                    Point: 0,
                    Banners: [],
                    RunningMessages: [],
                    GameCategories: [],
                    Games: [],
                    Wallets: [],
                    InGameId: '',
                }
                this.discover.RunningMessages = [
                    {
                        Id: '',
                        Message: 'BIG855 Online Gambling is wonderful only with you BIG855 opens the door to wealth',
                        MessageCn: 'BIG855 网上博彩 有你才精彩 BIG855 打开富贵门',
                        MessageTh: 'การพนันออนไลน์ BIG855 วิเศษสำหรับคุณเท่านั้น BIG855 เปิดประตูสู่ความมั่งคั่ง',
                        MessageVn: 'Cờ bạc trực tuyến BIG855 chỉ tuyệt vời khi có bạn BIG855 mở ra cánh cửa giàu có',
                        MessageId: 'Perjudian Online BIG855 luar biasa hanya dengan Anda BIG855 membuka pintu menuju kekayaan',
                        MessageKo: 'BIG855 온라인 도박은 당신과 함께 훌륭합니다 BIG855가 부의 문을 엽니다',
                        MessageTw: 'BIG855 网上博彩 有你才精彩 BIG855 打开富贵门',
                        MessageJp: 'BIG855 オンラインギャンブルはあなただけで素晴らしい BIG855 は富への扉を開きます'
                    }
                  ];

                this.discover.Banners = [
                    {
                        "Id": "afddfdb3-e07a-4874-9e41-40970d918b9c",
                        "Image": "../../assets/images/banner/banner2_en.jpg",
                        "ImageCn": "../../assets/images/banner/banner2_en.jpg",
                        "ImageMy": "../../assets/images/banner/banner2_en.jpg",
                        "ImageTh": "../../assets/images/banner/banner2_en.jpg",
                        "ImageVn": "../../assets/images/banner/banner2_en.jpg",
                        "ImageId": "../../assets/images/banner/banner2_en.jpg"
                    }
                ];
            }
        });

        this.screenWidthSubscription$ = this.screenSizeService.getScreenWidth().subscribe(width => {
            this.screenWidth = width;
        });
    }

    public onRefreshClick(): void {
        this.refreshDetails().subscribe((resp: Discover) => {
            this.discover = resp;
        });
    }

    public onRestoreClick(): void {
        this.disableRestore = true;
        this.quitAndRefreshDetails().subscribe((resp: Discover) => {
            this.discover = resp;
            this.disableRestore = false;
        });
    }

    private quitAndRefreshDetails(): Observable<Discover> {
        return this.landingPageService.quitGame().pipe(
            switchMap(() => {
                return this.landingPageService.getDiscover();
            })
        );
    }

    private refreshDetails(): Observable<Discover> {
        return this.landingPageService.getDiscover();
    }
    
    onCloseChangePasswordDialog(): void {
        this.dialogService.closeChangePasswordDialog();
    }

    onCloseReportDialog(): void {
        this.dialogService.closeReportDialog();
    }
}
